import React from 'react';
import {Typography} from "@mui/material";
import {
  AuthorizationCardContainer,
  AuthorizationCardContent,
  AuthorizationCardSubtitle,
  AuthorizationTitle
} from "./styles/authorizationStyle";

const AuthorizationCard = ({payWithAch}) => {
  return <AuthorizationCardContainer>
    {!payWithAch && <AuthorizationTitle>
      Additional credit card processing fee applies
    </AuthorizationTitle>}
    <AuthorizationCardContent>
      <Typography variant='subtitle2' color='textPrimary'>
        Authorization Agreement
      </Typography>
      <AuthorizationCardSubtitle>
        I agree that all future payments to or facilitated by SecurSpace will be processed by
        the Dwolla or Stripe payment systems from the account I select for this payment method. In order
        to cancel this authorization, I will change my payment settings within my SecurSpace account.
      </AuthorizationCardSubtitle>
    </AuthorizationCardContent>
  </AuthorizationCardContainer>
}

export default AuthorizationCard;
